<div id="whole-page" class="grey-gradient-background">
  <div id="onboarding-bg">
    <div id="welcome-header" class="animated fadeIn text-fmblue">
      <span>{{ confirmRegistrationInfo?.tenant.name }}</span>
    </div>
    <br />
    <p class="fs-1 text-black d-flex justify-content-center sub-header m-3">
      Welcome, {{ confirmRegistrationInfo?.firstName }}
    </p>
    <p class="fs-2 text-black d-flex justify-content-center sub-header m-2">
      In order to get started, please set your Password, Signature, Initials and
      Picture!
    </p>

    <div id="onboarding-panel">
      <mat-stepper class="bg-transparent" #stepper>
        <mat-step
          [stepControl]="passwordFormGroup"
          errorMessage="Password and Confirm passwird is required."
        >
          <form [formGroup]="passwordFormGroup" class="w-100">
            <ng-template matStepLabel>Create Your Password</ng-template>
            <div id="passwordTemplate">
              <div class="w-50 m-3 shadow card">
                <div class="card-header main-header onboarding-step">
                  Create Your Password
                </div>
                <div
                  class="card-body d-flex flex-column justify-content-between"
                >
                  <div class="mt-3">
                    <mat-form-field class="w-100 p-2 mb-3">
                      <mat-label>Password</mat-label>
                      <input
                        matInput
                        [type]="showPassword ? 'text' : 'password'"
                        formControlName="password"
                      />
                      <mat-icon
                        matSuffix
                        (click)="showPassword = !showPassword"
                        >{{
                          showPassword ? 'visibility' : 'visibility_off'
                        }}</mat-icon
                      >
                    </mat-form-field>
                    <mat-form-field class="w-100 p-2">
                      <mat-label>Confirm Password</mat-label>
                      <input
                        matInput
                        [type]="showConfirmPassword ? 'text' : 'password'"
                        formControlName="confirmPassword"
                      />
                      <mat-icon
                        matSuffix
                        (click)="showConfirmPassword = !showConfirmPassword"
                        >{{
                          showConfirmPassword ? 'visibility' : 'visibility_off'
                        }}</mat-icon
                      >
                    </mat-form-field>
                    <div
                      *ngIf="!passwordsMatch"
                      class="text-danger m-2 d-flex justify-content-center"
                    >
                      Passwords do not match
                    </div>
                    <div
                      *ngIf="
                        confirmPassword?.errors?.pattern ||
                        password?.errors?.pattern
                      "
                      class="text-danger m-2 d-flex justify-content-center"
                    >
                      Password must be at least 8 characters long with at least
                      one uppercase, lowercase and numerical value
                    </div>
                  </div>
                  <div class="d-flex justify-content-end">
                    <mat-checkbox formControlName="acceptTerms"
                      >Accept Terms</mat-checkbox
                    >
                  </div>
                </div>
              </div>
            </div>
          </form>
        </mat-step>

        <mat-step>
          <ng-template matStepLabel>Add Your Signature</ng-template>
          <div class="w-100 m-3 shadow card">
            <div class="card-header main-header onboarding-step no-select">
              Add Your Signature
            </div>
            <div
              class="card-body d-flex justify-content-center align-items-center"
            >
              <div #signaturePad id="signaturePad" class="w-300px h-250px">
                <a
                  id="resetSignatureButton"
                  class="cursor-pointer unStyleLink"
                  (click)="resetSignature()"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-arrow-repeat"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"
                    />
                    <path
                      fill-rule="evenodd"
                      d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"
                    />
                  </svg>
                </a>
                <div id="sigSvgContainer">
                  <svg xmlns="http://www.w3.org/2000/svg"></svg>
                </div>
              </div>
            </div>
          </div>
        </mat-step>

        <mat-step>
          <ng-template matStepLabel>Add Your Initials</ng-template>
          <div class="w-100 m-3 shadow card">
            <div class="card-header main-header onboarding-step no-select">
              Add Your Initials
            </div>
            <div
              class="card-body d-flex justify-content-center align-items-center"
            >
              <div #initialsPad id="initialsPad" class="w-250px h-150px">
                <a
                  id="resetInitialsButton"
                  class="cursor-pointer unStyleLink"
                  (click)="resetInitials()"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-arrow-repeat"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"
                    />
                    <path
                      fill-rule="evenodd"
                      d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"
                    />
                  </svg>
                </a>
                <div id="initialsSvgContainer">
                  <svg xmlns="http://www.w3.org/2000/svg"></svg>
                </div>
              </div>
            </div>
          </div>
        </mat-step>

        <mat-step>
          <ng-template matStepLabel>Add Your Picture</ng-template>
          <div id="choosePicture">
            <app-image-picker
              (pictureSelected)="pictureChosen($event)"
            ></app-image-picker>
          </div>
        </mat-step>
      </mat-stepper>
    </div>

    <div id="onboarding-lower-panel">
      <button
        mat-raised-button
        (click)="tryCompleteRegistration()"
        class="m-3"
        type="submit"
      >
        Get Started
      </button>
    </div>
  </div>
</div>
